Bingo.SoldBySwiper = {};

Bingo.SoldBySwiper.init = function () {
    new Swiper('#sold-by-swiper', {
        slidesPerColumnFill: 'column',
        navigation: {
            nextEl: '.sold-by-swiper-outer .swiper-to-right',
            prevEl: '.sold-by-swiper-outer .swiper-to-left',
        },
        slideClass: 'swiper-slide',
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 0,
    });
};
